/// <reference path="../../../../typings/index.d.ts" />
/// <reference path='employeeSupplyUsage.module.ts' />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.EmployeeSupplyUsage {
    "use strict";

       import ISupplyUsageLineItem = Meevo.Model.ISupplyUsageLineItem;


    

    export class EmployeeSupplyUsageContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        

        durationIncrements;
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            timeoutService: angular.ITimeoutService,
            durationIncrements) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            //this.baseEndpoint = appSettings.API_ENDPOINTS.blockType + '/' + this.selectedSection.model.id + '/Locations';
            this.baseEndpoint = appSettings.API_ENDPOINTS.employeeSupplyUsage;
            this.sectionTemplatePath = "app/plugins/employeeSupplyUsage/sectionViews/";
            this.durationIncrements = durationIncrements;
            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeysBase(this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_MAIN);
            this.initializeSections();
  
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurity(this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_MAIN + this.securityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_MAIN", "main.html", true, false, this.baseEndpoint, "",
                    this.loggingService, this.dataService, this.durationIncrements, this.identityService, Meevo.Model.NounEnum.BlockTypeMain));
            }
            if (this.securityChecker.hasSecurity(this.securityKeys.DATA_BLOCKTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new HistorySection(0, "SECTION_HISTORY", "main.html", true, false, this.appSettings.API_ENDPOINTS.blockType, "",
                    this.loggingService, this.dataService, this.durationIncrements, this.identityService, Meevo.Model.NounEnum.BlockTypeMain));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.BlockType>();
            model.displayName = undefined;
        }
        
    }
}


    /*
        cachedUsageList: Array<ISupplyUsageLineItem> = [];
 
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $scope: angular.IScope,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker);

            this.baseEndpoint = appSettings.API_ENDPOINTS.employeeSupplyUsage;
            this.sectionTemplatePath = "app/plugins/employeeSupplyUsage/sectionViews/";
            this.initializeSections();
            this.buildCrudSecurityKeysBase(this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_MAIN);

        } */

        /**
         * Responsible for initializing all sections belonging to the maintenance service.
         * @return {}
         */
         /*
        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_MAIN + this.securityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_MAIN", "main.html", true, false, this.baseEndpoint, '',
                    this.loggingService, this.dataService, this.identityService,
                    Meevo.Model.NounEnum.EmployeeSupplyUsage, this.appSettings,
                    this.busyService, this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE,
                    this.switchState.bind(this),
                    this.modalService,
                    this.$translate,
                    this.$q,
                    this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_MAIN + this.securityParts.KEY_PART_READ
                ));
            }

          if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_HISTORY + this.securityParts.KEY_PART_READ)) {
                this.sections.push(new HistorySection(1, "SECTION_HISTORY", "history.html", false, true, this.baseEndpoint, 'list',
                    this.loggingService, this.dataService, this.identityService,
                    Meevo.Model.NounEnum.EmployeeSupplyUsage, this.appSettings, this.busyService, this.$scope, this.modalService, this.securityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_HISTORY + this.securityParts.KEY_PART_READ));
            }

            this.activate();
        } */

        /**
         * Enable/disable readonly state for context to show only custom buttons in some circumstances
         * */
        /* public switchState(productSearch: boolean = false): void {
            if (productSearch) {
                this.mode = Meevo.Model.MaintenanceFormState.Pending;
            } else {
                this.mode = Meevo.Model.MaintenanceFormState.Editing;
            }
        } */

        /**
         * Selects the specified section of the maintance form and activates it.
         * @param {Meevo.Components.CommonClasses.ICommonSection} section
         * @returns {}
         */
         /*
        selectSection(section: Meevo.Components.CommonClasses.ICommonSection): void {
            if (this.selectedSection && this.selectedSection != section && this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                this.selectedSection = section;

                if (!this.selectedSection.isLoaded && !this.selectedSection.handlesOwnCrud) {
                    let apiCall;

                    this.loadingInProgress = true;

                    switch (section.sectionId) {
                        case 0:
                            apiCall = this.getUsage();
                            break;
                        default:
                            apiCall = this.dataService.getSection(this.baseEndpoint, this.selectedSection.sectionEndpoint).then((data: any) => {
                                this.selectedSection.model = data;
                                this.selectedSection.activate();
                            });
                    }

                    apiCall.finally(() => { this.loadingInProgress = false });
                }
                this.usageTrackingLog(Meevo.Model.VerbEnum.PageViewEvent, null);
            }
        }
        */

        /**
         * Retrieve list of items for supply usage main tab
         * @returns {ng.IPromise<any>}
         * */
         /*
        private getUsage(): ng.IPromise<any> {
            let criteria;

            criteria = {
                pageNumber: 0,
                itemsPerPage: 10000,
                criteria: {
                    startDateTime: moment().startOf('day').toDate(),
                    endDateTime: moment().endOf('day').toDate()
                },
                filtered: true
            };

            return this.dataService.getListPaged(this.baseEndpoint, criteria)
                .then((data: Array<ISupplyUsageLineItem> | any) => {
                    for (var i = 0; i < data.length; i++) {
                        data[i]['quantityDisplay'] = Number(data[i]['quantity']).toFixed(2);
                    }
                    this.cachedUsageList = data;
                    this.selectedSection['usageList'] = this.cachedUsageList.slice();
                    this.selectedSection.activate();
                });
        }
        */

        /**
         * Saves the item currently being edited/added.
         */
         /*
        save(): angular.IPromise<any> {
            if (this.canSave) {
                let apiCall;

                this.loadingInProgress = true;

                switch (this.selectedSection.sectionId) {
                    case 0:
                        apiCall = this.dataService.update(this.baseEndpoint, this.selectedSection.preSave())
                            .then(() => {
                                this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`Updates saved.`);
                                this.selectSection(this.selectedSection); // trigger loading of usage list
                            });
                        break;
                    default:
                        apiCall = this.dataService.update(this.baseEndpoint, this.selectedSection.model, this.selectedSection.sectionEndpoint)
                            .then((data: any) => {
                                this.selectedSection.model = data;
                                this.selectedSection.activate();
                                this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`Updates saved.`);
                            });
                }

                return apiCall
                    .finally(() => {
                        this.loadingInProgress = false;
                        this.postUpdate(this.selectedSection.model);
                    });
            }
            return null;
        }
        */
        /**
         * Refreshing list to remove not saved undo markings
         */
         /*
        cancel(): void {
            if (this.canCancel) {
                if (this.selectedSection.sectionId === 0) {
                    this.selectedSection['usageList'] = this.cachedUsageList.slice();
                }
                super.cancel();
            }
        } */

        /**
         * Responsible for initializing the header of the maintenance service.
         * This gets called only if isPrimarySection = true.  It supplies the model loaded
         * for the section to the method so that dynamic content can populate the header.
         * @return {}
         */
        //initializeHeader(model: any): void {}
